import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Maintenance.scss';
import maintenanceImg from 'assets/images/maintenance/maintenance.png';
import Button from 'components/Button';

const Maintenance = () => {
  const navigate = useNavigate();

  return (
    <div className="maintenance-page">
      <div className="maintenance-container">
        <div className="image-wrapper">
          <img src={maintenanceImg} alt="Maintenance" />
        </div>
        <div className="text-content">
          <h1 className="title">This Site is Under Maintenance</h1>
          <p className="description">
            We are currently performing some scheduled maintenance to ensure everything is running smoothly. 
            Please try again in a few moments. We apologize for any inconvenience!
          </p>
          <div className="button-group">
            <Button
              title="Try Again"
              type="violet"
              onClick={() => window.location.href = '/signin'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
